module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-10.89a54fc1.svg";